<template>
  <div class="c-text-between px-container c-flex-wrap">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <span class="c-mb-10" style="text-align: left;">欢迎莅临我们即将举办的行业活动与贸易展览会</span>
      <h1>活动</h1>
      <span class="c-mt-5 c-mb-10 c-text-left ">
       与Franka Robotics相约全球。加入我们参与顶级行业展会、贸易展览及科研会议，我们将在此展示机器人与人工智能领域的最新创新成果。了解我们的系统如何赋能工业自动化、教育及科研领域——并与我们的团队交流，探索Franka Robotics如何助您达成目标。
      </span>
    </div>

    <div class="display-width">
      <img src="@/assets/images/events/image00053.jpeg" alt="" style="    height: auto; width: 100%;">
    </div>
  </div>
  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">即将到来的</span>
    <hr class="divider">
  </div>
  <div class="c-text-between px-container c-mb-60">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>未来的活动</h1>
    </div>
  </div>

  <div class="c-text-justify-start px-container  c-flex-wrap" style="margin-bottom: 120px;gap:50px">
    <div class="action-width c-text-column" v-for="item in eventList" :key="item.openUrl">
      <div class="c-mb-5 c-text-both" style="overflow: hidden;aspect-ratio: 716/450;">
        <img :src="item.url" alt="" class="image-style" style="height: auto;  max-width: 100%;max-height: 100%;" @click="openPage(item.openUrl, '_blank')">
      </div>
      <div class="c-text-left c-width-precent-100 c-mt-10">
        {{ item.location }}
      </div>
      <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-5">
        {{ item.name }}
      </h3>
      <h3 class="c-text-left c-width-precent-100 c-mb-10">
        {{ item.time }}
      </h3>
      <div class="c-text-left c-width-precent-100">
        {{ item.value }}
      </div>
      <div class="c-text-between" style="text-align: left;">
        <div class="linkTag">

          <a :href="item.openUrl" target='_blank' rel="noopener noreferrer">
            了解更多</a>
        </div>
      </div>
    </div>
    <!-- <div class="action-width c-text-cocolumn "> 
        <div class="c-mb-5"  style="overflow: hidden;aspect-ratio: 716/450;">
          <img src="@/assets/images/events/ERF2025-news.png"  class="image-style" alt="" style="height: auto; max-width: 100%;">
        </div>
        <div class="c-text-left c-width-precent-100 c-mt-10">
          斯图加特，德国
        </div>
        <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-5">
          ERF（欧洲机器人论坛）   
        </h3>
        <h3 class="c-text-left c-width-precent-100 c-mb-10">
          2025年3月25日至27日
        </h3>
        <div class="c-text-left c-width-precent-100">
          该论坛不仅展示了机器人领域的最新趋势，还促进了有意义的合作，激发了变革性思维，赋能于行业、研究和整个社会。
        </div>
        <div class="c-text-between" style="text-align: left;">
          <div class="linkTag">
            了解更多
          </div> 
        </div> 
    </div> 
    <div class="action-width c-text-cocolumn"> 
        <div class="c-mb-5" style="overflow: hidden;aspect-ratio: 716/450;">
          <img src="@/assets/images/events/23-TA-11-019-FExD-ICRA-Logo-1-RGB.jpg" class="image-style" alt="" style=" height: auto; max-width: 100%;">
        </div>
        <div class="c-text-left c-width-precent-100 c-mt-10">
          美国，亚特兰大
        </div>
        <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-5">
          ICRA（国际机器人与自动化会议） 
        </h3>
        <h3 class="c-text-left c-width-precent-100 c-mb-10">
          2025年5月19日至23日
        </h3>
        <div class="c-text-left c-width-precent-100">
          ICRA 2025将汇聚世界顶级研究人员和行业领袖，分享思想、交流知识，并推动机器人领域的发展，以造福人类。
        </div>
        <div class="c-text-between" style="text-align: left;">
          <div class="linkTag">
            了解更多
          </div> 
        </div> 
    </div>  -->
  </div>

  <div class="line-with-text px-container">
    <hr class="divider">
    <span class="line-text">近期事件</span>
    <hr class="divider">
  </div>
  <div class="c-text-between px-container c-mb-60">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>近期活动</h1>
    </div>
  </div>
  <div class="px-container stress-content">
    <div v-for="(item, index) in contentList" :key="item.name + index"
      style="display: flex; flex-direction: column; min-height: 180px;">
      <div style="width: 100%; overflow: hidden;" class="c-text-both">
        <img :src="item.url" class="image-style"
          style="width: 100%; height: 100%; object-fit: cover;aspect-ratio: 211 / 133;" />
      </div>
      <div class="c-text-left c-width-precent-100 c-mt-10">
        {{ item.name }}
      </div>
      <h3 class="c-text-left c-width-precent-100 c-mt-10 c-mb-10">
        {{ item.title }}
      </h3>
      <div class="c-text-left c-width-precent-100 text-indent">
        {{ item.value }}
      </div>
    </div>
  </div>

</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'App',
  components: {
    // HelloWorld
  },
  data() {
    return {
      eventList: [
        {
          location:'慕尼黑，德国',
          name:'EUROPE EMBODIED',
          time:'6月22日至26日',
          value:'Europe Embodied 汇聚了来自欧洲各地的研究人员、企业与志向远大的学生，旨在巩固欧洲在机器人领域的技术领导地位。',
          url:require('@/assets/images/events/4-2.jpg'),
          openUrl:'https://europe-embodied.com/'
        },
        {
          location:'德国，不来梅',
          name:'IJCAI',
          time:'8月15日至21日',
          value:'第35届国际人工智能联合会议（IJCAI-ECAI 2026）是一场全球顶级的人工智能盛会，由欧洲人工智能协会（EurAI）联合组织，并得到意大利人工智能协会（AIxIA）的支持。大会汇集了研究人员、开发者和行业专业人士，共同探讨人工智能从基础研究到应用技术、伦理人工智能以及以人为本的人工智能倡议等各方面的最新进展。',
          url:require('@/assets/images/events/3-3.jpg'),
          openUrl:'https://2026.ijcai.org/'
        },
        {
          location:'美国，匹兹堡',
          name:'IROS',
          time:'9月27日至10月1日',
          value:'IEEE/RSJ智能机器人与系统国际会议（IROS）是全球规模最大、最具影响力的机器人研究会议之一。本次大会将在匹兹堡汇聚研究人员、工程师与行业领袖，这座城市处于机器人创新的前沿，拥有世界知名机构以及领先的自动驾驶汽车公司。',
          url:require('@/assets/images/events/2-2.jpg'),
          openUrl:'https://2026.ieee-iros.org/'
        },
        {
          location:'美国，奥斯汀',
          name:'CoRL',
          time:'11月9日至12日',
          value:'机器人学习会议（CoRL）是一个科学会议，旨在分享和探讨机器人技术与机器学习交叉领域的最新进展。自2017年创办以来，CoRL一直致力于推动这些充满活力的领域的前沿研究与创新。',
          url:require('@/assets/images/events/1-2.jpg'),
          openUrl:'https://www.corl.org/home'
        },

      ],
      contentList: [
        {
          name: '奥地利，维也纳',
          title: 'ICRA 2026，5月17日至22日',
          value: 'ICRA是IEEE机器人与自动化学会的旗舰会议，将汇聚全球机器人领域的领导者，通过主题演讲、研讨会和展览分享最新研究、创新成果与行业发展。',
          url: require('@/assets/images/events/1780398223085.jpeg'),
        },
        {
          name: '美国，波士顿',
          title: 'ROBOTICS SUMMIT & EXPO 2026',
          value: '机器人峰会暨博览会汇聚了6000多名开发人员，他们正在为航空航天与国防、医疗保健、物流、制造等市场打造机器人。在机器人创新的核心地带，与会者深入了解了最新的使能技术、工程最佳实践和新兴趋势。',
          url: require('@/assets/images/events/1780066901403.jpeg'),
        },
        {
          name: '美国拉斯维加斯',
          title: 'Google Cloud Next 2026',
          value: 'Google Cloud Next 展示了人工智能和云技术的最新进展，汇聚了全球领导者、思想家和实践者的社群。Franka Robotics 展示了由 Google DeepMind Gemini Robotics 1.5 驱动的 FR3 Duo 机器人，演示了实时规划与自适应多步操作。',
          url: require('@/assets/images/events/1777632390558.jpg'),
        },
        {
          name: '德国汉诺威',
          title: '汉诺威工业博览会 2026',
          value: '汉诺威工业博览会再次巩固了其作为工业转型领先平台的地位。Franka Robotics 与 Agile Robots 携手，成功展示了真实的工业应用场景，其中 Franka Robotics 为在实际工业任务中部署机器人提供了基础支持。',
          url: require('@/assets/images/events/1777048777306.jpg'),
        },
        {
          name: '挪威，斯塔万格',
          title: '欧洲机器人论坛（ERF）2026',
          value: '欧洲机器人论坛（ERF）是欧洲机器人及人工智能领域的顶级盛会，汇聚了来自工业界、学术界和公共部门的1000多名参会者。',
          url: require('@/assets/images/events/ERF-2026_ Team 1_resized.jpg'),
        },
        {
          name: '美国，圣何塞',
          title: 'NVIDIA GTC 2026 大会',
          value: 'NVIDIA GTC 是全球领先的人工智能大会，面向开发者、研究人员和行业领袖，共同探索下一波人工智能创新浪潮。从物理人工智能、人工智能工厂，到智能体人工智能与推理，GTC 2026 集中展示了正在塑造各行各业的突破性进展。',
          url: require('@/assets/images/events/1774019367491.jpg'),
        },
        {
          name: '德国，科隆',
          title: 'GRC 2026 大会',
          value: '本次活动汇聚了来自政界、科学界、工业界及初创企业的顶尖代表，旨在加强研究、创新与技术转移之间的衔接。',
          url: require('@/assets/images/events/GRC 2026_ 66_resized.jpg'),
        },

        {
          name: '东京,日本',
          title: 'IREX',
          value: '2025.12.03-12.06 Franka Robotics 圆满结束 “iREX 2025（国际机器人展）” 的精彩旅程！感谢全球伙伴的热切关注！我们带来了一系列颠覆性技术和产品，FR3 Duo力感知遥操作，基于Gemini VLA 的FR3 Duo任务演示以及FR3 Duo柔性力控漆扇绘制，引来诸多观众及潜在客户驻足围观。全面展示了我们在机器人科研及人工智能领域的领先实力。',
          url: require('@/assets/images/events/c0a6e95839c143976f8cee3293713bf7.jpg'),
        },
        {
          name: '杭州，中国',
          title: 'IROS',
          value: 'IROS为全球机器人研究界提供了一个重要平台，共同探讨智能机器人与智慧机械领域的前沿进展，聚焦未来发展方向，并展示最新研究方法、技术方案与创新成果。',
          url: require('@/assets/images/events/iROS booth_resized.jpg'),
        },

        {
          name: '首尔,韩国',
          title: 'CoRL/ HUMANOIDS',
          value: '在CoRL 2025会议上，我们团队展示了Franka 机器人系列的最新研发成果，包括自适应机器人底座、Franka MATLAB工具箱。通过此次会议，我们不仅深化了与科研伙伴的合作关系，还启动了多项新的联合研究计划。',
          url: require('@/assets/images/events/1759397019544.jpeg'),
        },

        {
          name: '上海，中国',
          title: '中国国际工业博览会',
          value: '作为中国装备制造业最具影响力的展会之一，工博会推动工业技术创新与发展，促进国际交流与合作。',
          url: require('@/assets/images/events/9f9ddb91a5f6d8be33900b1e46cf78cd.jpg'),
        },
        {
          name: '慕尼黑，德国',
          title: 'AUTOMATICA',
          value: '作为智能自动化与机器人领域的旗舰级行业盛会，本届慕尼黑automatica展会系统整合关键前沿技术，有力推动产业应用、学术研究与政策制定三者之间的战略协同。',
          url: require('@/assets/images/events/1750846160085 (1).jpg'),
        },

        {
          name: '德国·斯图加特',
          title: 'ERF',
          value: '这场盛会不仅展现了机器人领域的最新趋势，更搭建了深度协作的桥梁，激发了赋能工业界、学术界乃至整个社会的变革性创想。',
          url: require('@/assets/images/events/IMG_7457-1_ERF _Official Photos.jpg')
        },
        {
          name: '纽伦堡，德国',
          title: 'GRC',
          value: '德国机器人大会（GRC）是德国乃至欧洲机器人领域的重要学术与产业交流平台，聚焦机器人技术、自动化及人工智能的创新与应用。Franka Robotics与学术界和工业界专家研究分享机器人行业界的技术转化与国际合作，促进欧洲机器人技术的产业化发展。',
          url: require('@/assets/images/events/1743474254021.jpg')
        },
        {
          name: '斯图加特，德国',
          title: 'ERF',
          value: 'Franka Robotics出席欧洲机器人论坛（ERF），欧洲最具影响力的机器人学术与产业盛会，汇聚全球顶尖专家包括英伟达机器人研究高级总监，奔驰集团COO等展示前沿研究成果与技术创新。与Franka机器人共探人工智能及行业应用，推动欧洲及全球机器人领域发展。',
          url: require('@/assets/images/events/1743474347193.jpg')
        },
        {
          name: '法国南锡',
          title: '人形机器人',
          value: '会议邀请了与人形机器人相关的各个领域的原创论文投稿以及工作坊/教程提案。会议还举办了机器人竞赛、大型工业展览，以及面向儿童和公众的推广活动。',
          url: require('@/assets/images/events/PXL_20241122_095012915.MP.jpg')
        },
        {
          name: '慕尼黑，德国',
          title: 'CoRL',
          value: '该年度国际会议聚焦于机器人技术与机器学习的交叉领域。CoRL 2024 会议将于 2024 年 11 月 6 日至 9 日在德国慕尼黑举行，关于参会和投稿的所有重要信息均可在相关部分找到。',
          url: require('@/assets/images/events/PXL_20241106_101216244.jpg')
        },
        {
          name: '欧登塞，丹麦',
          title: 'ROSCON',
          value: '此次活动将来自不同技能水平的ROS开发者汇聚在一起，为期三天的学习与交流。通过工作坊、讲座和教程，参与者深入了解新工具，并加深了对现有工具的知识。通过多样的演讲、座谈会和实践环节，ROSCon加强了全球ROS社区，并鼓励了来自弱势群体的参与。',
          url: require('@/assets/images/events/Image (69)-1.png')
        },
        {
          name: '维尔茨堡，德国',
          title: 'COBOTS4YOU',
          value: '该倡议使机器人使用更加普及，并为参观者提供了关于当前应用可能性和协作机器人优势的全面信息。',
          url: require('@/assets/images/events/Image (23).png')
        },
        {
          name: '阿布扎比，阿联酋',
          title: '人形机器人',
          value: '此次会议将聚焦于“可持续发展的机器人技术”。活动将通过大会演讲、工作坊和技术会议探讨机器人技术如何推动可持续发展目标，为新兴研究人员和从业者提供一个展示贡献和进行知识交流的平台。',
          url: require('@/assets/images/events/1729170620255-1 (1).png')
        },
        {
          name: '卢加诺，瑞士',
          title: 'HFR',
          value: 'HFR 2024 聚焦于人机交互，强调机器人在人类日常或工业任务中的安全且有意义的合作。此次活动旨在将研究人员和行业专业人士汇聚一堂，讨论该领域的最新成果、发现、应用和挑战。研讨会采用单轨形式，以最大化所有参与者之间的互动。',
          url: require('@/assets/images/events/IMG_0489.jpg')
        },
        {
          name: '上海，中国',
          title: 'CIIF',
          value: 'CIIF 通过汇聚专家和领导者，推动新兴产业和新经济，推动高端行业的创新。此次活动突出了各行业的技术趋势，强调开放、创新和包容的工业生态系统的重要性。它作为一个平台，展示智能和可持续制造供应链的全貌，从关键部件到尖端设备。',
          url: require('@/assets/images/events/1699948898067-NH-5.jpg')
        },


        {
          name: '代尔夫特，荷兰',
          title: 'RSS',
          value: '机器人学：科学与系统”（RSS）会议的第20届将在全球范围内汇聚来自机器人学各领域的研究人员，开展为期一周的精彩和集中的交流活动。会议将包括单轨报告、工作坊、海报展示和教程。今年将继续征集机器人学社区中的杰出成果。',
          url: require('@/assets/images/events/RSS1-3.png')
        },
        // {
        //   name:'帕萨迪纳，美国',
        //   title:'RO-MAN',
        //   value:'本次会议的主题是“拥抱以人为本的人机交互（HRI）”，重点通过理解人类需求并创建理想的机器人系统，推动人机交互（HRI）的发展。此次努力旨在提高人类的生活质量，并造福未来世代。会议为研究人员和实践者提供了一个平台，探索机器人与人类互动沟通的各个方面，包括理论、方法、技术和实证研究，促进对人机交互未来的洞察。',
        //   url:require('@/assets/images/events/IMG_0978.jpg')
        // }, 
        {
          name: '斯图加特，德国',
          title: 'KROX',
          value: '来自知名企业和新兴厂商的激动人心的创新。关于机器人技术所有当前和重要趋势与话题的实践报告、主题演讲、专题讨论和工作坊。现场演示以及一个广泛的展览，提供丰富的交流空间',
          url: require('@/assets/images/events/PXL_20240620_135721090-1.jpg')
        },

        {
          name: '横滨，日本',
          title: 'ICRA',
          value: 'ICRA汇聚了来自全球的机器人学研究人员、学生和工业合作伙伴，讨论最新的创新和突破，突出机器人技术和自动化在应对全球挑战中的作用。ICRA 2024将包括全体会议和主题演讲、投稿论文会议、工作坊和教程会议、论坛、展览会以及来自企业合作伙伴的展览、机器人竞赛和众多社交活动。',
          url: require('@/assets/images/events/ICRA_Team 2024.jpg')
        },
        // {
        //   name:'圣何塞，美国',
        //   title:'NVIDIA GTC',
        //   value:'本次会议连接了行业领袖、开发者、研究人员和商业策略师，共同塑造人工智能和加速计算的未来。从NVIDIA首席执行官黄仁勋的备受期待的主题演讲，到超过900场鼓舞人心的会议、200多个展览、20多个技术工作坊以及众多独特的社交活动，GTC为各个技术水平和兴趣领域的与会者提供了丰富的内容。',
        //   url:require('@/assets/images/events/1711463945952.jpg')
        // }, 
        {
          name: '里米尼，意大利',
          title: 'ERF',
          value: '该论坛特别旨在促进终端用户、研究人员和技术生产商之间的互动，最终目标是提高工业竞争力，促进科学进步，激发行业利益相关者之间的网络合作，并识别机器人技术的新应用场景，带来深远的影响。',
          url: require('@/assets/images/events/24-03-15 10-15-39 0785.jpg')
        },
        {
          name: '慕尼黑，德国',
          title: '上海交通大学参访Franka Robotics',
          value: '位于慕尼黑的Franka Robotics总部，迎来了上海交通大学中银科技金融学院师生们的参访。作为世界一流的人工智能与机器人研究平台，我们为师生们介绍了Franka Robotics如何助力人工智能与机器人研究以及为应用场景的自动化提供用户友好的解决方案。',
          url: require('@/assets/images/events/1741327973254.jpg')
        },
      ]
    }
  },
  methods: {
    openPage(url, target) {
      window.open(url, target)
    }
  }
}
</script>

<style scoped>
.action-width {
  width: calc(25% - 50px);
}


/* 导航栏容器的样式 */
nav {
  color: #1B2F36;
  /* 背景色 */
}


/* 栅格布局，将 <ul> 设置为水平排列 */
ul.navbar {
  list-style-type: none;
  display: flex;
  padding: 10px;
}

/* 每个 <li> 的样式 */
ul.navbar li {
  position: relative;
  /* 相对定位，用于子菜单的绝对定位 */
  /* margin: 0 20px;   */
}

/* 链接的样式 */
ul.navbar li a {
  text-decoration: none;
  /* 去掉下划线 */
  font-size: 14px;
  padding: 10px 15px;
  /* 内边距 */
  display: block;
}

/* 子菜单（下拉菜单）样式 */
ul.dropdown-menu {
  /* border: 1px solid #1b2f364f; */
  border: 1px solid #e5e7eb;
  box-sizing: border-box;
  list-style-type: none;
  position: absolute;
  /* 绝对定位 */
  top: 100%;
  /* 放置在父菜单项的下方 */
  left: 0;
  background-color: white;
  /* 背景色 */
  display: none;
  /* 初始状态下隐藏 */
  width: 150px;
  /* 设置子菜单宽度 */
  border-radius: 5px;
  /* 圆角 */
  padding: 5px;
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);  */
}


/* 鼠标悬停时显示子菜单 */
ul.navbar li:hover>.dropdown-menu {
  display: block;
  /* 显示子菜单 */


}

/* 默认情况下，一行展示 4 个项目 */
.stress-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  /* 项目之间的间隔 */
}

.company-content {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.stress-content>div {
  width: calc(25% - 20px);
  /* 4 个项目 */
}

.company-content>div {
  width: calc(16.5% - 40px);
  /* 4 个项目 */
}

.display-width {
  width: calc(50% - 40px);
}

.ending-width {
  width: 35%;
}

.logo-alt {
  display: none;
  /* 默认隐藏 logo.svg */
}


@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 25px);
  }
}


/* 屏幕宽度小于 1200px 时，一行展示 3 个 */
@media (max-width: 1199px) {
  .stress-content>div {
    width: calc(33.33% - 20px);
    /* 3 个项目 */
  }

  .company-content>div {
    width: calc(25% - 40px);
    /* 3 个项目 */
  }

  .logo-main {
    display: none;
    /* 隐藏 logo-and-claim.svg */
  }

  .logo-alt {
    display: block;
    /* 显示 logo.svg */
  }
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .stress-content>div {
    width: calc(50% - 20px);
    /* 2 个项目 */
  }

  .company-content>div {
    width: calc(33% - 40px);
    /* 3 个项目 */
  }

  .display-width {
    width: 100%
  }

  .ending-width {
    width: 100%;
    margin-top: 40px;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .stress-content>div {
    width: 100%;
    /* 1 个项目 */
  }

  .company-content>div {
    width: calc(50% - 40px);
    /* 3 个项目 */
  }

  .action-width {
    width: calc(100%);
  }
}
</style>
<style scoped>
/* h2 {
  font-size: 14px;
  margin-top: 10px;
  color: #333;
} */
</style>
